<template>
    <v-row justify="center">
    <v-dialog v-model="dialogCreate" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Uploader un média</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
                <v-col cols='12'>
                    <v-text-field label="Titre" v-model="createdMedia.title" hide-details="auto"></v-text-field>
                </v-col>
                <v-col cols='12'>
                    <v-file-input label="File input" v-model="mediaFile"></v-file-input>
                </v-col>
                <v-col cols="6">
                    <v-combobox
                    v-model="createdMedia.meta.ref"
                    :items="referenceItems.values"
                    :label="referenceItems.libelle"
                    multiple
                    dense
                    hide-details
                    chips
                    ></v-combobox>
                </v-col>
                <v-col cols="6">
                    <v-select
                    v-model="createdMedia.meta.type"
                    :items="typeItems"
                    item-text="Libelle"
                    item-value="value"
                    label="Type"
                    multiple
                    dense
                    hide-details
                    chips
                    ></v-select>
                </v-col>
                <v-col cols="6">
                    <v-select
                    v-model="createdMedia.meta.brand"
                    :items="brandItems"
                    item-text="Libelle"
                    item-value="value"
                    label="Marque"
                    multiple
                    dense
                    hide-details
                    chips
                    ></v-select>
                </v-col>
                <v-col cols="6">
                    <v-select
                    v-model="createdMedia.meta.product"
                    :items="productsItems"
                    item-text="Libelle"
                    item-value="value"
                    label="Produits"
                    multiple
                    dense
                    hide-details
                    chips
                    ></v-select>
                </v-col>
                <v-col cols="6">
                    <v-combobox
                    v-model="createdMedia.meta.utilisation"
                    :items="utilisationItems.values"
                    :label="utilisationItems.libelle"
                    multiple
                    dense
                    hide-details
                    chips
                    ></v-combobox>
                </v-col>
                <v-col cols="6">
                    <v-combobox
                    v-model="createdMedia.meta.tags"
                    :items="tagItems.values"
                    :label="tagItems.libelle"
                    multiple
                    dense
                    hide-details
                    chips
                    ></v-combobox>
                </v-col>
                <v-col cols="12">
                    <v-textarea
                        label="Commentaire"
                        :value="createdMedia.meta.comment"
                    ></v-textarea>
                </v-col>
            </v-row>
          </v-container>
          <div v-show="showPercentage">
            <v-progress-linear
                v-model="percentage"
                color="primary"
                height="5"
                ></v-progress-linear>
                <p class="text-center">Téléchargement en cours</p>
            </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="showPercentage" color="blue darken-1" text @click="dialogCreate = false">Annuler</v-btn>
          <v-btn :disabled="showPercentage" color="blue darken-1" text @click="sendNewMedia">Envoyer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
    name: 'CreateModal',
     data () {
        return {
            mediaFile: [],
            createdMedia : {
                title: "",
                meta: {
                    ref: [],
                    name: [],
                    type: [],
                    brand: [],
                    utilisation: [],
                    product: [],
                    tags: [],
                    comment: []
                },
            },
            percentage: 0,
            showPercentage: false
        }
    },
    created() {
    },
    computed: {
        dialogCreate: {
            get () {
                return this.$store.state.dialogCreate
            },
            set (value) {
                this.$store.dispatch('setDialogCreate', value)
            }
        },
        referenceItems: function(){
            return this.$store.state.infosMetas.ref
        },
        nameItems: function(){
            return this.$store.state.infosMetas.name
        },
        typeItems: function(){
            return this.$store.state.listItems.types
        },
        brandItems: function(){
            return this.$store.state.listItems.brand
        },
        productsItems: function(){
            return this.$store.state.listItems.products
        },
        utilisationItems: function(){
            return this.$store.state.infosMetas.utilisation
        },
        tagItems: function(){
            return this.$store.state.infosMetas.tags
        },
        commentItems: function(){
            return this.$store.state.infosMetas.comment
        }
    },
    methods : {
        sendNewMedia(){
            if(this.createdMedia != ""){
                this.showPercentage = true;
                var vm = this;
                var xmlHTTP= new XMLHttpRequest();
                xmlHTTP.upload.addEventListener("progress", function(e) {
                            var position = e.position || e.loaded;
                            var total = e.totalSize || e.total;
                            vm.percentage = Math.round((position/total)*100);
                        }, false);
                xmlHTTP.open("PUT", process.env.VUE_APP_API_URL+'upload?key='+this.$store.state.apiKey, true);
               
                xmlHTTP.onreadystatechange = function() {
                    if (xmlHTTP.readyState === 4) {
                        vm.showPercentage = false;
                        let response;
                        try {
                            response = JSON.parse(xmlHTTP.response);
                        } catch (e) {
                            response = xmlHTTP.response
                        }
                        vm.$store.dispatch('sendNewMedia', response.media)
                        this.mediaFile = [];
                        this.createdMedia.title = "";
                        this.createdMedia.meta = {
                            ref: [],
                            name: [],
                            type: [],
                            brand: [],
                            utilisation: [],
                            product: [],
                            tags: [],
                            comment: []
                        }
                        this.percentage = 0;
                        this.$store.dispatch('setDialogCreate', false)
                    }
                }
                xmlHTTP.setRequestHeader( 'title' , this.utoa(this.createdMedia.title));
               
                for (const [key, value] of Object.entries(this.createdMedia.meta)) {
                    if(value.length > 0){
                        xmlHTTP.setRequestHeader( 'meta_'+key , this.utoa(`${value}`));
                    }
                }
                xmlHTTP.send(this.mediaFile);
            }   
        },
        isJson(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        },
        utoa(data) {
            return btoa(unescape(encodeURIComponent(data)));
        }
    },
    watch : {

    }
}
</script>
